import React, { useState, useContext, useEffect } from "react"
import styled from "styled-components"
import { Menu, Accordion, Loader, Button, Icon } from "semantic-ui-react"
import { GenderContext } from "../../providers/GenderProvider"
import { device } from "../../theme"
import Brands from "./brands"
import { ProductContext } from "../../providers/ProductProvider"
import Category from "./category"
import Shop from "./shop"
import MyFavorites from "./myfavorites"
import { FilterContext } from "../../providers/FilterProvider"
import MobileSorting from "./MobileSorting"
import MobileSearch from "./mobileSearch"
import MobileShop from "./mobileShop"
import SortPrices from "./sortPrices"
import { FavoritesContext } from "../../providers/MyFavorites"
import { Link } from "gatsby"
import { BrandsContext } from "../../providers/BrandsProvider"
import { displayCategory } from "../../utils/displayCategory"

const Container = styled.aside`
  position: sticky;
  top: 75px;
  z-index: 1000;
  width: ${props => props.theme.sidebarWidth};
  height: 100%;

  @media ${device.tablet} {
    display: none;
  }

  & .item .title {
    position: relative;

    & .ui.active.loader {
      right: 0;
      left: inherit;
      transform: translate(0px, -50%);
    }
  }
`

const ActiveSpan = styled.span`
  font-size: 14px;
  color: #999;
  margin-left: 4px;
`

const Buttons = styled.div`
  display: none;
  margin-top: 32px;
  @media ${device.tablet} {
    display: flex;
    justify-content: space-between;
  }
`

const SortButton = styled(Button)`
  background: ${props => props.theme.colors.green} !important;
  color: #fff !important;
  width: calc(50% - 1rem);
  white-space: nowrap;
  margin: -1rem 0 22px !important;
`

const ShopButton = styled(Link)`
  background: transparent !important;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.colors.green} !important;
  border: 1px solid ${props => props.theme.colors.green} !important;
  width: calc(50% - 1rem);
  white-space: nowrap;
  margin: -1rem 0 22px !important;
  border-radius: 4px;
`

const ListItem = styled(Menu.Item)`
  padding-left: 0 !important;
`

const CurrentTitle = ({ title, selected }) => (
  <>
    {title} {selected && <ActiveSpan>({selected})</ActiveSpan>}
  </>
)

function Sidebar({ shop, gender, category }) {
  const { favorites } = useContext(FavoritesContext)
  const { setBrands, brands } = useContext(BrandsContext)
  const [isOpen, setOpen] = useState(false)
  const { state } = useContext(FilterContext)
  const { isLoading } = useContext(ProductContext)
  const [activeIndex, setIndex] = useState(0)
  const [shopOpen, setShopOpen] = useState(false)
  const [sortBy, setSort] = useState("relevans")

  const handleClick = (e, titleProps) => {
    const { index } = titleProps
    const newIndex = activeIndex === index ? -1 : index
    setIndex(newIndex)
  }

  const handleSort = () => {
    if (sortBy === "lowest") return "Laveste pris"
    if (sortBy === "highest") return "Højeste pris"
    return "Relevans"
  }

  const sortBrandsAlphabetically = brandsArray => brandsArray.sort()

  const fetchBrands = async () => {
    // Get brands on first render
    const activeGender = gender === "herre" ? "men" : "women"
    let url = `https://static8-api.herokuapp.com/lineout/brands?gender=${activeGender}&category=${category}`
    await fetch(url)
      .then(res => res.json())
      .then(e => {
        setBrands(sortBrandsAlphabetically(e))
      })
      .catch(err => console.log(err))
  }

  React.useEffect(() => {
    fetchBrands()
  }, [])

  return (
    <React.Fragment>
      <>
        {/* <MobileSearch /> */}
        <Buttons>
          <SortButton onClick={() => setOpen(!isOpen)}>
            Sorter <Icon name="filter" style={{ marginLeft: 10 }} />
          </SortButton>
          <ShopButton to="/mine-favoritter">Mine favoritter</ShopButton>
        </Buttons>
        <MobileSorting
          activeCategory={displayCategory(category)}
          category={category}
          gender={gender}
          shop={shop}
          isOpen={isOpen}
          setOpen={setOpen}
          brands={brands}
        />
      </>

      <Container>
        <Accordion
          style={{
            borderRadius: 0,
            background: "transparent",
            boxShadow: "none",
            border: "none",
          }}
          as={Menu}
          vertical
        >
          <ListItem>
            <Accordion.Title
              active={activeIndex === 0}
              content={
                <CurrentTitle
                  title="Kategori"
                  selected={displayCategory(category)}
                />
              }
              icon={isLoading ? <Loader size="mini" active /> : null}
              index={0}
              onClick={
                isLoading
                  ? e => e.preventDefault()
                  : (e, titleProps) => handleClick(e, titleProps)
              }
            />
            <Accordion.Content
              active={activeIndex === 0}
              content={<Category gender={gender} />}
            />
          </ListItem>

          <ListItem>
            <Accordion.Title
              active={activeIndex === 1}
              content={
                <CurrentTitle
                  title="Mærker"
                  selected={
                    state.selectedBrands.length
                      ? `${state.selectedBrands.length}`
                      : ""
                  }
                />
              }
              icon={isLoading ? <Loader size="mini" active /> : null}
              index={1}
              onClick={
                isLoading
                  ? e => e.preventDefault()
                  : (e, titleProps) => handleClick(e, titleProps)
              }
            />
            <Accordion.Content
              active={activeIndex === 1}
              content={
                <Brands brands={brands} category={category} gender={gender} />
              }
            />
          </ListItem>
          <ListItem>
            <Accordion.Title
              active={activeIndex === 2}
              content={<CurrentTitle title="Sorter" selected={handleSort()} />}
              icon={isLoading ? <Loader size="mini" active /> : null}
              index={2}
              onClick={
                isLoading
                  ? e => e.preventDefault()
                  : (e, titleProps) => handleClick(e, titleProps)
              }
            />
            <Accordion.Content
              active={activeIndex === 2}
              content={
                <SortPrices
                  active={sortBy}
                  setActive={setSort}
                  category={category}
                  gender={gender}
                />
              }
            />
          </ListItem>
          <ListItem>
            <Accordion.Title
              active={activeIndex === 3}
              content={
                <CurrentTitle
                  title="Mine favoritter"
                  selected={`${favorites.length}`}
                />
              }
              icon={isLoading ? <Loader size="mini" active /> : null}
              index={3}
              onClick={
                isLoading
                  ? e => e.preventDefault()
                  : (e, titleProps) => handleClick(e, titleProps)
              }
            />
            <Accordion.Content
              active={activeIndex === 3}
              content={<MyFavorites favorites={favorites} />}
            />
          </ListItem>
        </Accordion>
      </Container>
    </React.Fragment>
  )
}

export default Sidebar
